/**
 * Helpers to convert a camelCase review form into a service-contract shape.
 * Handles field renaming, kebab-case fixes, and legacy data defaults.
 *
 * Callers are responsible for calling snakeToCamel() before passing data here.
 */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "convertFormModelToServiceContract", {
    enumerable: true,
    get: function() {
        return convertFormModelToServiceContract;
    }
});
const _bson = require("bson");
const _helper = require("../../questions/helper");
const convertFormModelToServiceContract = (input)=>{
    if (!input || typeof input !== "object") {
        return input;
    }
    const camelCasedForm = input;
    const result = {
        _id: camelCasedForm._id,
        companyId: camelCasedForm.company,
        baseId: camelCasedForm.baseId,
        name: camelCasedForm.name,
        createdAt: camelCasedForm.createdAt,
        createdBy: camelCasedForm.creator || null,
        updatedAt: camelCasedForm.updatedAt || null,
        updatedBy: camelCasedForm.updatedBy || null
    };
    // Include questionsCount if present (for ReviewFormWithoutQuestions / list view)
    // Check this first — list view data has both `questions` (ObjectId array) and `questionsCount`,
    // and we don't want to process the ObjectId array as question documents.
    if (camelCasedForm.questionsCount !== undefined) {
        return {
            ...result,
            questionsCount: camelCasedForm.questionsCount
        };
    }
    // Include questions array if present (for ReviewFormWithQuestions / detail view)
    if (camelCasedForm.questions !== undefined) {
        const questions = Array.isArray(camelCasedForm.questions) ? camelCasedForm.questions.filter((question)=>!_bson.ObjectID.isValid(question)).map(_helper.convertQuestionModelToServiceContract) : camelCasedForm.questions;
        return {
            ...result,
            questions
        };
    }
    return result;
};
